// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"account":"7c24f873","administration":"db4731e1"}[chunkId] + ".chunk.js";
};